<template>
  <div class="o-dialog">
    <!-- 组件：遮罩 -->
    <transition
      name="dialog-mask-transition"
      enter-active-class="animated fadeIn"
    >
      <div
        id="J_mask"
        class="c-mask"
        v-if="dialog.isActive"
        @click.prevent="hideDialog(dialog.id)"
      ></div>
    </transition>
    <transition
      name="dialog-mask-transition"
      enter-active-class="animated fadeIn"
    >
      <div
        id="J_c-pop"
        :class="[
          dialog.id == 'bank-pay'
            ? 'c-pop bank-pop'
            : dialog.id == 'store-tips'
            ? 'c-pop store-tips-wrap'
            : 'c-pop'
        ]"
        v-if="dialog.isActive"
      >
        <loading v-if="!dialog.isLoaded"></loading>
        <ul class="o-sels" v-if="dialog.isLoaded && dialog.id == 'game'">
          <li
            class="o-sels_sel"
            v-for="game in games"
            @click="
              select({
                id: game.id,
                txt: game.name,
                ctrlId: dialog.id,
                notClose: true
              })
            "
            :key="game.id"
          >
            {{ game.name }}
          </li>
        </ul>
        <ul class="o-sels" v-if="dialog.isLoaded && dialog.id == 'sfq'">
          <li
            class="o-sels_sel"
            v-show="dialog.ctrl.sfq.len"
            v-for="sfq in getSfqLists"
            :key="sfq.ID"
            @click="
              select({
                id: sfq.ID,
                sid: sfq.SID,
                txt: sfq.NAME,
                ctrlId: dialog.id,
                notClose: true
              })
            "
          >
            {{ sfq.NAME }}
          </li>
          <li
            class="o-sels_sel"
            v-show="!dialog.ctrl.sfq.len"
            v-for="(sfq, index) in getSfqLists"
            :key="index"
          >
            {{ sfq.NAME }}
          </li>
        </ul>
        <ul class="o-sels" v-if="dialog.isLoaded && dialog.id == 'role'">
          <li
            class="o-sels_sel"
            v-show="dialog.ctrl.role.len"
            v-for="role in getRoleLists"
            :key="role.roleID"
            @click="
              select({ id: role.roleID, txt: role.roleName, ctrlId: dialog.id })
            "
          >
            {{ role.roleName }}
          </li>
          <li
            class="o-sels_sel"
            v-show="!dialog.ctrl.role.len"
            v-for="(role, index) in getRoleLists"
            :key="index"
          >
            {{ role.roleName }}
          </li>
        </ul>
        <ul class="o-sels" v-if="dialog.isLoaded && dialog.id == 'region'">
          <li
            class="o-sels_sel"
            v-for="region in regions"
            @click="
              select({ id: region.id, txt: region.name, ctrlId: dialog.id })
            "
            :key="region.id"
          >
            {{ region.name }}
          </li>
        </ul>
        <ul class="o-sels" v-if="dialog.isLoaded && dialog.id == 'bank'">
          <li
            class="o-sels_sel"
            v-for="(bank, index) in getBankLists"
            :key="index"
            @click="
              selBank({
                pay: bank.pay,
                fpay: bank.fpay,
                txt: bank.txt,
                currency: bank.currency,
                ctrlId: dialog.id
              })
            "
          >
            {{ bank.txt }}
          </li>
        </ul>
        <ul class="o-sels" v-if="dialog.isLoaded && dialog.id == 'operator'">
          <li
            class="o-sels_sel"
            v-for="(operator, index) in getOperatorLists"
            :key="index"
            @click="
              selBank({
                pay: operator.pay,
                fpay: operator.fpay,
                txt: operator.txt,
                currency: operator.currency,
                ctrlId: dialog.id
              })
            "
          >
            {{ operator.txt }}
          </li>
        </ul>

        <!-- 游戏币弹窗列表 -->
        <ul
          class="o-sels"
          v-if="dialog.isLoaded && dialog.id == 'gameCurrency'"
        >
          <li
            class="o-sels_sel"
            v-for="product in getGameCurrency"
            :key="product.PRODUCT_ID"
            @click="
              select({
                id: product.PRODUCT_ID,
                txt: product.PRODUCT_DESC,
                remark: product.REMARK,
                ctrlId: 'product',
                tip: product.PRODUCT_NOTICE[0]
              })
            "
          >
            {{ product.PRODUCT_DESC }}
          </li>
        </ul>

        <!-- 月卡/禮包弹窗列表 -->
        <ul class="o-sels" v-if="dialog.isLoaded && dialog.id == 'package'">
          <li
            class="o-sels_sel"
            v-for="product in getPackage"
            :key="product.PRODUCT_ID"
            @click="
              select({
                id: product.PRODUCT_ID,
                txt: product.PRODUCT_DESC,
                remark: product.REMARK,
                ctrlId: 'product',
                tip: product.PRODUCT_NOTICE[0]
              })
            "
          >
            {{ product.PRODUCT_DESC }}
          </li>
        </ul>

        <!-- 银行汇款渠道支付面板 -->
        <div class="o-pay" v-if="dialog.isLoaded && dialog.id == 'bank-pay'">
          <p class="o-pay_info">
            <span class="o-pay_key">遊戲名稱：</span>
            <span class="o-pay_value">{{ getBankPayData.gameName }}</span>
          </p>
          <p class="o-pay_info">
            <span class="o-pay_key">服務器：</span>
            <span class="o-pay_value">{{ getBankPayData.sfqName }}</span>
          </p>
          <p class="o-pay_info">
            <span class="o-pay_key">角色名：</span>
            <span class="o-pay_value">{{ getBankPayData.roleName }}</span>
          </p>
          <p class="o-pay_info">
            <span class="o-pay_key">儲值金額：</span>
            <span class="o-pay_value">
              {{ getBankPayData.amount.split(/\=|\/|\s/)[0] }}
            </span>
          </p>
          <p
            class="o-pay_info"
            v-if="
              pays.bank &&
              pays.bank.channelInfo &&
              pays.bank.channelInfo.name == 'maxis'
            "
          >
            <span class="o-pay_key">電話號碼：</span>
            <span class="o-pay_value">{{ getBankPayData.msisdn }}</span>
            }
          </p>
          <div class="c-qr">
            <button
              class="c-qr_btn"
              @click.prevent="checkLoginAndPay(getBankPayData.id)"
            >
              確認付款
            </button>
          </div>
        </div>
        <!-- 没输入点卡提示 -->
        <ul class="o-sels" v-if="dialog.isLoaded && dialog.id == 'input-tips'">
          <li class="o-sels_sel">請先輸入卡號和密碼~</li>
        </ul>
        <!-- 1月23号0点-1月29号22点期间显示储值提示弹窗-->
        <ul
          class="o-sels store-tips"
          v-if="dialog.isLoaded && dialog.id == 'store-tips'"
        >
          <li class="o-sels_sel">
            《日理萬姬》新春活動期間所有官方平臺儲值首儲
            <span class="red">翻倍福利</span>
            將重置，與加碼福利同時享受，自
            <span class="red">2020/1/23日0點起</span>
            ，即可恢復所有首儲翻倍機會。
            <br />
            <span class="red bold">參與伺服器：平步青雲、金榜題名</span>
          </li>
        </ul>
      </div>
    </transition>

    <!-- 对象：step2：统计完成选角数据 -->
    <!-- <img class="c-coll" v-if="this.statistics.step2 && this.dialog.ctrl.role.id" :src="'//collectdata.gm99.com/ps.gif?id=3&at=2&ext='+this.statistics.plat+'&e1='+this.statistics.os+'&timestamp='+this.statistics.timestamp" alt=""> -->
    <!-- 对象：step4：统计选择金额数据 -->
    <!-- <img class="c-coll" v-if="this.statistics.step4" :src="'//collectdata.gm99.com/ps.gif?id=3&at=4&ext='+this.statistics.plat+'&e1='+this.statistics.os+'&timestamp='+this.statistics.timestamp" alt=""> -->
    <!-- 对象：step5：统计完成订单提交数据 -->
    <!-- <img class="c-coll" v-if="this.statistics.step5" :src="'//collectdata.gm99.com/ps.gif?id=3&at=5&ext='+this.statistics.plat+'&e1='+this.statistics.os+'&timestamp='+this.statistics.timestamp+'&active='+this.statistics.step5active" alt=""> -->
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { GET_LOGIN_STATUS } from '../../store/twStore';
import loading from './loading.vue';

import Api from '../../utiles/twStore/js/common/api.js';
import globalConfig from '../../utiles/globalConfig';
import {
  getGlobalGetGotoLink,
  getGlobalGetLinkParams
} from '@utiles/globalGetLink';
const mainHost = globalConfig.getMainHost();

export default {
  name: 'Dialogs',
  data() {
    return {
      msg: 'Hello Channel Face!',
      isLoaded: true,
      step2url: '',
      games: this.dialog.lists.games,
      sfqs: this.dialog.lists.sfqs,
      roles: this.dialog.lists.roles,
      regions: this.dialog.lists.regions,
      channelId: null,
      channelInfo: null,
      isPlaying: false
    };
  },
  components: {
    loading
  },
  props: {
    dialog: {
      type: Object,
      required: true
    },
    isPay: {
      type: Boolean
    },
    pays: {
      type: Object,
      required: true
    }
  },
  computed: {
    getSfqLists() {
      return this.dialog.lists.sfqs;
    },

    getRoleLists() {
      return this.dialog.lists.roles;
    },

    serialProducts() {
      let temps = [];
      let products = this.dialog.lists.products;
      for (let i = 0, l = products.length; i < l; i++) {
        let lists = products[i].list;
        temps = temps.concat(lists);
      }
      return temps;
    },

    getGameCurrency() {
      let temps = [];
      let products = this.dialog.lists.products;
      for (let l = products.length, i = l - 1; i >= 0; i--) {
        temps = temps.concat(products[i].list);
      }
      return temps;
    },

    getPackage() {
      let temps = [];
      let products = this.dialog.lists.products;
      for (let i = 0, l = products.length; i < l; i++) {
        if (products[i].catalog !== '遊戲幣') {
          temps = temps.concat(products[i].list);
        }
      }
      return temps;
    },

    // 計算實時bank渠道支付數據
    getBankPayData() {
      return this.pays.bank;
    },

    // atm银行列表
    getBankLists() {
      return this.dialog.lists.banks;
    },

    // 运营商列表
    getOperatorLists() {
      return this.dialog.lists.operator;
    }
  },
  methods: {
    // 暴露接口方法
    ...mapMutations([
      'doSelect',
      'doGetChannels',
      'doSelBank',
      'getProduct',
      'doGetProduct',
      'showTip',
      'showDialog',
      'doPay',
      'doDefaultPay',
      'changeDialogId',
      'changeDialogLoaded',
      'changeDialogSfqLen',
      'changeDialogRolesLen',
      'changeDialoglistsSfq',
      'resetDialogSfq',
      'resetDialogRole',
      'changeDialoglistsRole',
      'setAccount'
    ]),

    getSfqs(fn) {
      this.changeDialogLoaded(false);
      let self = this;
      let selObj = this.$store.state.store.dialog.ctrl;
      let gameId = selObj.game.id;
      let key = 'SFQS_' + gameId;

      let tipCall = function () {
        this.showDialog('game');
      };

      let fail = function (res) {
        this.changeDialogLoaded(true);
        Api.log(res);
        this.hideDialog('game');
        this.showTip({
          txt: '獲取伺服器失敗！',
          call: tipCall.bind(this)
        });
      };

      Api.ajax({
        localKey: key,
        url: `//gstore.${mainHost}/ajax/server_list`,
        type: 'get',
        dataType: 'jsonp',
        data: {
          game_id: gameId
        }
      }).then(function (res) {
        Api.log(res);
        self.changeDialogLoaded(true);
        self.changeDialogSfqLen(res.data.length);
        self.changeDialoglistsSfq(
          res.data.length > 0
            ? res.data
            : [{ NAME: '暫無伺服器，請重新選擇！' }]
        );
        typeof fn === 'function' && fn(res);
        res.isAjax && Api.cacheMode(key, res.data);
      }, fail.bind(this));
    },

    getRole(fn) {
      // this.dialog.isLoaded = false;
      this.changeDialogLoaded(false);
      let self = this;
      let selObj = this.$store.state.store.dialog.ctrl;
      let gameId = selObj.game.id;
      let sfqId = selObj.sfq.id;
      let key = 'ROLE_' + gameId + '_' + sfqId;

      let succ = function (res) {
        Api.log(res);
        // this.dialog.isLoaded = true;
        self.changeDialogLoaded(true);
        self.changeDialogRolesLen(res.data.length);
        self.changeDialoglistsRole(
          res.data.length > 0
            ? res.data
            : [{ roleName: '暫無角色，請重新選擇！' }]
        );
        typeof fn === 'function' && fn();
        res.isAjax && Api.cacheMode(key, res.data);
      };
      Api.ajax({
        localKey: key,
        url: `//gstore.${mainHost}/ajax/get_user_role/`,
        type: 'get',
        dataType: 'jsonp',
        data: {
          game_id: gameId,
          server_id: sfqId
        }
      }).then(succ.bind(this), succ.bind(this));
    },

    hideDialog(type) {
      this.$store.commit('hideDialog', type);
    },
    select(sel) {
      this.doSelect(sel);
      switch (sel.ctrlId) {
        case 'game': {
          // 获取伺服器列表
          this.resetSfq();
          this.resetRole();
          const that = this;
          this.getSfqs(function () {
            that.changeSels('sfq');
          });

          if (this.isPay) {
            this.dialog.id = null;
            window.location.href = '#/';
          }
          break;
        }
        case 'sfq': {
          // 获取对应角色
          this.resetRole();
          const that = this;
          this.getRole(function () {
            that.changeSels('role');
          });
          break;
        }
        case 'role': {
          // 重新选择角色之后需重置商品
          // 选角后重返渠道选择页面
          this.$parent.showPayWaySelecter = true;
          if (this.isPay) {
            this.resetProduct();
            let channelId = this.$store.state.store.channelId;
            if (
              channelId === 'mycard_webatm' ||
              channelId === 'mycard_telephone'
            ) {
              this.getBankProduct();
            } else {
              this.getProduct();
            }
          }
          break;
        }
        case 'region': {
          this.isPay && (window.location.href = '#/');
          break;
        }
      }
      !sel.notClose && this.$store.commit('hideDialog', sel.ctrlId);
    },

    selBank(sel) {
      this.resetProduct(); // 重置已選擇的金額
      this.doSelBank(sel);
      this.hideDialog(sel.ctrlId);
      this.getBankProduct();
    },

    changeSels(id) {
      this.changeDialogId(id);
    },

    resetSfq() {
      let sfq = this.dialog.ctrl.sfq;
      if (parseInt(sfq.id)) {
        // this.dialog.lists.sfqs.length = 0;
        // sfq.id = 0;
        // sfq.txt = "請選擇伺服器";
        // sfq.len = 0;
        // this.sfqs.length = 0; // 清空伺服器列表
        this.resetDialogSfq();
      }
      // this.sfqs.length = 0; // 清空伺服器列表
    },

    resetRole() {
      let role = this.dialog.ctrl.role;
      if (parseInt(role.id)) {
        this.resetDialogRole();
      }
    },

    resetProduct() {
      let product = this.dialog.ctrl.product;
      if (product.id) {
        product.id = 0;
        product.txt = '請選擇付款金額';
      }
    },

    /**
     * 订单提交支付
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    pay(id) {
      switch (id) {
        case 'bank': {
          this.bankPay();
          break;
        }
        case 'web-atm': {
          this.atmPay();
          break;
        }
        case 'call': {
          this.callPay();
          break;
        }
        case 'mcds': {
          this.mcdsPay();
          break;
        }
        case 'ctpay': {
          this.ctPay();
          break;
        }
        default: {
          this.defaultPay();
        }
      }
    },

    /**
     * 银行汇款渠道订单提交
     * @return {[type]} [description]
     */
    bankPay() {
      let pays = this.getBankPayData;
      let ctrl = this.dialog.ctrl;
      let gameId = ctrl.game.id;
      let sfqId = ctrl.sfq.id;
      let roleId = ctrl.role.id;
      let roleName = ctrl.role.txt;
      let pay = pays.pay;
      let currency = pays.currency;
      let remark = ctrl.product.remark;
      let succ = function (res) {
        this.setAccount(res.data.virtual_account_info.virtual_account);
        this.hideDialog('bank-pay');
        this.showTip(
          `發票處理事宜：於匯款完成七日內，請至下方『操作說明』選擇發票處理方式，若逾期未選擇，發票將默認捐贈“社團法人台灣偵搜犬協會”不做他用。`
        );
      };
      let fail = function (res) {
        this.hideDialog('bank-pay');
        if (res?.msg === 'no available character') {
          // 后端不处理，前端骚操作
          this.showTip(res.msg);
        } else {
          this.showTip('請選擇伺服器/角色信息');
        }
      };
      Api.ajax({
        url: `//gstore.${mainHost}/virtual_account/submit/`,
        type: 'post',
        dataType: 'JSON',
        xhrFields: { withCredentials: true },
        // crossDomain: true,
        data: {
          gameId: gameId,
          serverId: sfqId,
          paytype: pay,
          currency: currency,
          roleId: roleId,
          roleName: roleName,
          remark: remark,
          cid: globalConfig.getHrefParamUndecode('cid') || '',
          scid: globalConfig.getHrefParamUndecode('scid') || '',
          ...getGlobalGetLinkParams()
        }
      }).then(succ.bind(this), fail.bind(this));
    },

    /**
     * Web-ATM渠道订单提交
     * @return {[type]} [description]
     */
    atmPay() {
      let pays = this.getBankPayData;
      let pay = pays.pay;
      let fpay = pays.fpay;
      let currency = pays?.currency;

      let params = {
        fpay: fpay,
        data: {
          paytype: pay,
          currency: currency
        }
      };

      this.doPay(params);
    },

    callPay() {
      let ctrl = this.dialog.ctrl;
      let pay = ctrl.bank.pay;
      let fpay = ctrl.bank.fpay;
      let currency = ctrl.bank?.currency;

      let params = {
        fpay: fpay,
        data: {
          paytype: pay,
          currency: currency
        }
      };
      this.doPay(params);
    },

    /**
     * ct-vue组件对应的支付方式
     * @return {[type]} [description]
     */
    ctPay() {
      let succ = function (res) {
        this.hideDialog('bank-pay');
        if (res.data.type === '2') {
          this.dialog.ctpay.formCommit = true;
          this.dialog.ctpay.redirectUrl = res.data.redirect_url;
          this.dialog.ctpay.postFields = res.data.post_fields;

          // 提交表单
          var formEl = document.getElementById('J_ct_form');
          var timer = setInterval(function () {
            if (formEl) {
              clearInterval(timer);
              formEl.submit();
            }
            formEl = document.getElementById('J_ct_form');
          }, 50);
        } else {
          window.open(res.data.redirect_url, '_self');
        }
      };
      let param = {
        succ: succ.bind(this)
      };

      this.doDefaultPay(param);
    },

    mcdsPay() {
      let succ = function (res) {
        this.hideDialog('bank-pay');
        if (res.data.type === '2') {
          this.dialog.mcds.hasPay = true;
          this.dialog.mcds.postFields = res.data.post_fields;
        } else {
          window.open(res.data.redirect_url, '_self');
        }
      };
      let param = {
        succ: succ.bind(this)
      };

      this.doDefaultPay(param);
    },

    defaultPay() {
      this.doDefaultPay();
    },

    // 根据银行/运营商子渠道获取商品：atm/手机市话宽频渠道
    getBankProduct() {
      let pays = this.dialog.ctrl.bank;
      let fpay = pays.fpay;
      let pay = pays.pay;
      let currency = pays?.currency;

      let params = {
        fpaytype: fpay,
        paytype: pay,
        currency: currency
      };
      let succ = function (res) {
        this.dialog.lists.products = res.data;
        res.isAjax && Api.cacheMode(res.key, res.data);
      };

      this.doGetProduct({
        data: params,
        succ: succ.bind(this)
      });
    },
    checkLoginAndPay(id) {
      if (this.isPlaying) {
        return;
      }
      this.isPlaying = true;
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch(GET_LOGIN_STATUS)
          .then(login => {
            if (!login) {
              this.doLogin();
            } else {
              this.pay(id);
            }
            setTimeout(() => {
              this.isPlaying = false;
            }, 1500);
          })
          .catch(e => {
            this.isPlaying = false;
            console.error(e);
          });
      });
    },
    doLogin() {
      const twStoreHref = getGlobalGetGotoLink({ link: window.location.href });
      window.location.href =
        `https://pay.3syua.com/platform/login.html?gameId=161&forward=` +
        encodeURIComponent(twStoreHref);
    }
  }
};
</script>
